<template>
  <div class="fcc-specs" :class="floorplan == undefined ? 'no-floorplan' : ''">
    <div class="holder">
      <FCTitle :h2="h2" :h3="h3" />
      <div class="specs">
        <div
          class="spec"
          v-for="(item, index) in specs"
          :key="index"
          :data-aos-delay="index*200"
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-easing="ease-out-cubic"
        >
          <img :src="require(`@/assets/icons/benefits/${item.icon}`)" alt />
          <div class="text">
            <div v-html="item.text" />
          </div>
        </div>
      </div>
    </div>
    <img
      v-if="floorplan !== undefined"
      class="floorplan"
      :src="require(`@/assets/maps/${floorplan}`)"
      alt
      data-aos="zoom-in-up"
      data-aos-duration="250"
      data-aos-easing="ease-out-cubic"
    />
  </div>
</template>

<script>
import FCTitle from "@/components/patterns/FCTitle";
export default {
  components: {
    FCTitle,
  },
  props: {
    h2: String,
    h3: String,
    specs: Array,
    floorplan: String,
  },
};
</script>

<style lang="scss" scoped>
.fcc-specs {
  background-image: linear-gradient(
    270deg,
    rgba(5, 17, 42, 0.84) 52%,
    rgba(0, 0, 0, 0.84) 100%
  );
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.floorplan {
  position: relative;
  top: 275px;
  left: 100px;
  max-height: 60vh;
  max-width: calc(55vw - 150px);
  z-index: 1;
}
.holder {
  position: absolute;
  top: 160px;
  right: 0;
  margin-right: 100px;
  width: 375px;
}
.no-floorplan {
  background-image: linear-gradient(
    270deg,
    rgba(5, 17, 42, 0.84) 52%,
    rgba(0, 0, 0, 0) 100%
  );
  .holder {
    width: 475px;
  }
  .spec {
    img {
      vertical-align: top;
    }
    .text {
      width: 375px;
      div {
      }
    }
  }
}
.spec {
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  .text {
    display: inline-block;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 1;
    color: #ffffff;
    vertical-align: middle;
    padding: 20px 15px;
    padding-left: 15px;
    height: auto;
    width: 275px;
    box-sizing: border-box;
    text-align: left;
    strong {
      font-size: 32px;
      font-weight: bold;
    }
  }
  img {
    vertical-align: middle;
    width: 61px;
    height: 61px;
  }
}
.map {
  margin-top: 50px;
  img {
    width: 100%;
    height: 50vh;
    object-fit: contain;
    object-position: top left;
  }
}
@media (max-width: 1000px) {
  .fcc-specs {
    background-image: linear-gradient(90deg, #07173a 0%, #030a18 100%);
    height: auto;
    box-sizing: border-box;
    position: static;
    min-height: 100vh;
    overflow: auto;
    padding: 25px;
    padding-bottom: 75px;
    .floorplan {
      margin-top: 20px;
      position: static;
      width: calc(100vw - 50px);
      max-width: unset;
      object-fit: contain;
      object-position: center;
    }
    .spec {
      display: flex;
    }
    .holder {
      position: static;
      width: 100%;
      margin: 0;
    }
  }
}
</style>